import { toast } from "@/blyn/legacy/components/toast";

export function toastApiError(label: string, err?: unknown) {
  const msg =
    err instanceof Error ? err.message
    : typeof err === "string" ? err
    : "Request failed";
  toast("danger", label, msg, 5000);
}
